import { useEffect } from 'react';

import type { MutableRefObject } from 'react';
// RAT binding implementation for click events
// https://confluence.rakuten-it.com/confluence/pages/viewpage.action?pageId=2617778545
const useRatBindClickComponent = (node: MutableRefObject<HTMLElement | null>) => {
  useEffect(() => {
    if (node.current && window.RAT) {
      window.RAT.bind(window.RAT.$Selector(node.current));
    }
  }, []);
};

export default useRatBindClickComponent;
